import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    // Only bounce to /login when the 401 comes from Aanar's own auth flow.
    // Third-party broker 401s (Alpaca cred rejection etc.) must NOT log the user out.
    const url = err?.config?.url || "";
    const isBroker3rdParty = /\/broker\/|\/ibkr\//.test(url);
    const status = err?.response?.status;
    const cfg = err?.config;

    // ---- Silent access-token refresh ----
    // If the request 401'd (and it wasn't a broker 3P call, wasn't already a
    // retry, and wasn't the refresh endpoint itself), try to rotate the pair
    // once and replay the original request.
    if (status === 401 && cfg && !cfg._retried
        && !isBroker3rdParty
        && !url.includes("/auth/refresh")
        && !url.includes("/auth/login")
        && !url.includes("/auth/register")) {
      const refresh = localStorage.getItem("refresh_token");
      if (refresh) {
        cfg._retried = true;
        try {
          // Use a bare axios instance so we don't recurse through this interceptor
          const { data } = await axios.post(`${API_BASE}/auth/refresh`, { refresh_token: refresh });
          if (data?.token) {
            localStorage.setItem("token", data.token);
            if (data?.refresh_token) localStorage.setItem("refresh_token", data.refresh_token);
            cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${data.token}` };
            return api(cfg);
          }
        } catch { /* fall through to logout below */ }
      }
    }

    if (status === 401
        && !window.location.pathname.startsWith("/login")
        && !window.location.pathname.startsWith("/forgot-password")
        && !window.location.pathname.startsWith("/reset-password")
        && !isBroker3rdParty) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fmtMoney = (n, digits = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
  if (abs >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
};

export const fmtPct = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n >= 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
};

export const fmtQty = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return n.toLocaleString(undefined, { maximumFractionDigits: 6 });
};
